<app-practice-module-logs-filter></app-practice-module-logs-filter>
<app-practical-module-logs-content></app-practical-module-logs-content>